<template>
  <h1 class="system_content_title">评价工作管理</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px; width: 100%;">
      <!-- <el-button style="float: left" type="success" @click="handleAdd(resetFormData)">新增</el-button> -->
      <el-table v-loading="myData.Loading" :data="myData.tableData" stripe style="width: 100%">
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="yearNum" label="年度" />
     
        <el-table-column prop="comNum" label="参评数量">
          <template #header>
            <el-tooltip
              effect="dark"
              content="参评数量"
              placement="top-start"
            >
              <span
                style="
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                "
                >参评数量</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template v-slot="scope">
            <el-tag v-if="scope.row.status === 0" type="success">正常</el-tag>
            <el-tag v-if="scope.row.status === 3" type="warning">已结束</el-tag>
            <el-tag v-if="scope.row.status === 4" type="danger">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" />
        <!-- <el-table-column label="说明文件">
          <template v-slot="scope">
            <el-link type="success" :href="baseUrl + scope.row.FileUrl" :underline="false" target="_blank">
              {{ getFileName(scope.row.FileUrl) }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="公示文件">
          <template v-slot="scope">
            <el-link type="success" :href="baseUrl + scope.row.FileUrl1" :underline="false" target="_blank">
              {{ getFileName(scope.row.FileUrl1) }}
            </el-link>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="发布文件">
          <template v-slot="scope">
            <el-link type="success" :href="baseUrl + scope.row.FileUrl2" :underline="false" target="_blank">
              {{ getFileName(scope.row.FileUrl2) }}
            </el-link>
          </template>
        </el-table-column> -->
        <el-table-column prop="createTime" label="创建时间"  width="100">
            <template #default="scope">
          <span>{{scope.row.createTime.replace("T",' ')}}</span>
            </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="240">
          <template #default="scope">
            <!-- <el-button size="small" type="default" @click="handleEdit(scope.row)">编辑</el-button> -->
            <!-- <el-button size="small" type="danger" @click="handleDel(scope.row.Id)">删除</el-button> -->
            <el-button size="small" type="warning" @click="handleDetails(scope.row)">进入企业管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[20, 60, 80, 100]" :page-size="myData.params.rows" background layout="total, sizes, prev, pager, next, jumper"
        :total="myData.total">
      </el-pagination>
    </div>
  </div>
  <el-dialog v-model="myData.dialogVisible" :title="myData.title" :close-on-click-modal="false"
    :before-close="handleClose">
    <el-form ref="resetFormData" :model="myData.form" label-width="120px" label-position="top">
      <el-form-item label="标题" prop="Title">
        <el-input v-model="myData.form.Title" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="流程名称" prop="FlowName">
        <el-input v-model="myData.form.FlowName" placeholder="请输入流程名称" />
      </el-form-item>
      <el-form-item label="流程代码" prop="FlowCode">
        <el-input v-model="myData.form.FlowCode" placeholder="请输入流程代码" />
      </el-form-item>
      <el-form-item label="指标类型" prop="AppraiseTypeCode">
        <el-select-v2 style="width:100%" v-model="myData.form.AppraiseTypeCode" :options="myData.options"
          placeholder="请选择指标类型" />
      </el-form-item>
      <el-form-item label="备注" prop="Remark">
        <el-input v-model="myData.form.Remark" maxlength="3000" placeholder="请输入备注" show-word-limit type="textarea" />
      </el-form-item>
      <el-form-item label="说明文件" prop="FileUrl">
        <el-upload v-if="!myData.form.FileUrl" action="#" :show-file-list="false" :http-request="handleUpload1">
          <el-button type="default" :icon="Upload" size="small">上传说明文件</el-button>
        </el-upload>
        <div v-else>
          <el-link style="color: blue;" :href="baseUrl + myData.form.FileUrl" :underline="false" target="_blank">
            {{ getFileName(myData.form.FileUrl) }}
          </el-link>
          <span style="margin-left:10px; cursor:pointer;" @click="handleReset1">
            <el-icon style="vertical-align: middle;">
              <CircleCloseFilled />
            </el-icon>
          </span>
        </div>
      </el-form-item>
      <el-form-item label="公式文件" prop="FileUrl1">
        <el-upload v-if="!myData.form.FileUrl1" action="#" :show-file-list="false" :http-request="handleUpload2">
          <el-button type="default" :icon="Upload" size="small">上传公式文件</el-button>
        </el-upload>
        <div v-else>
          <el-link style="color: blue;" :href="baseUrl + myData.form.FileUrl1" :underline="false" target="_blank">
            {{ getFileName(myData.form.FileUrl1) }}
          </el-link>
          <span style="margin-left:10px; cursor:pointer;" @click="handleReset2">
            <el-icon style="vertical-align: middle;">
              <CircleCloseFilled />
            </el-icon>
          </span>
        </div>
      </el-form-item>
      <el-form-item label="发布文件" prop="FileUrl1">
        <el-upload v-if="!myData.form.FileUrl2" action="#" :show-file-list="false" :http-request="handleUpload3">
          <el-button type="default" :icon="Upload" size="small">上传发布文件</el-button>
        </el-upload>
        <div v-else>
          <el-link style="color: blue;" :href="baseUrl + myData.form.FileUrl2" :underline="false" target="_blank">
            {{ getFileName(myData.form.FileUrl2) }}
          </el-link>
          <span style="margin-left:10px; cursor:pointer;" @click="handleReset3">
            <el-icon style="vertical-align: middle;">
              <CircleCloseFilled />
            </el-icon>
          </span>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="handleSave"> 保存 </el-button>
        <el-button @click="myData.dialogVisible = false">取消</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { onMounted, getCurrentInstance, reactive, ref ,onBeforeUnmount} from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { Upload, CircleCloseFilled } from '@element-plus/icons-vue'
import CONSTS from "../../store/consts";
import api from "../../http/apis"
const router = useRouter()
const { proxy } = getCurrentInstance()
const resetFormData = ref(null);
const baseUrl = CONSTS.BASE_URL;
const myData = reactive({
  title: '',
  dialogVisible: false,
  tableData: [],
  Loading: true,
  total: 0,
  options: [],
  form: {
    AppraiseTypeCode: '',
    Title: '',
    FlowName: '',
    FlowCode: '',
    ComNum: null,
    Remark: '',
    FileUrl: '',
    FileUrl1: '',
    FileUrl2: '',
  },
  params: {
    value: '',
    page: 1,
    rows: 20,
    order: 'desc',
    sort:""
  }
})

onMounted(() => {
  getTableData()
  // getAppraiseTypeCode()
})

const handleAdd = (formEl) => {  // 打开窗口
  myData.title = '新增工作任务'
  myData.dialogVisible = true
  if (!formEl) return
  resetFormData.value.resetFields()
}

const handleClose = (done) => { // 关闭窗口
  done()
}

const getAppraiseTypeCode = () => { // 获取指标类型
  proxy.$httpApi.getAppraiseTypeCode().then(res => {
    if (res.IsSuccessful) {
      const arrList = res.ResultObj;
      arrList.forEach(item => {
        myData.options.push({
          value: item.Code,
          label: item.Name
        })
      })
    } else {
      ElMessage({
        message: res.ResultMsg,
        type: "error",
      })
    }
  })
}

const getTableData =async () => { // 获取列表数据
  myData.Loading = true
  const {data}=await api.reviewTaskApi.getTaskList(myData.params)
 
    if (data.isSuccessful) {
      myData.Loading = false
      myData.tableData = data.resultObj.data
      myData.total = data.resultObj.pagerInfo.totalRowCount
    } else {
      ElMessage({
        message: data.resultMsg,
        type: "error",
      })
      myData.Loading = false
    }
  
}

const handleEdit = (item) => { // 编辑
  myData.title = '编辑工作任务'
  myData.form.Id = item.Id
  myData.form.Title = item.Title
  myData.form.AppraiseTypeCode = item.AppraiseTypeCode
  myData.form.FlowName = item.FlowName
  myData.form.FlowCode = item.FlowCode
  myData.form.ComNum = item.ComNum
  myData.form.Remark = item.Remark
  myData.form.FileUrl = item.FileUrl
  myData.form.FileUrl1 = item.FileUrl1
  myData.form.FileUrl2 = item.FileUrl2
  myData.dialogVisible = true
}
 const enterSearch = (e) => {
      if (e.key == "Enter") {
        getTableData();
      }
    };

    window.addEventListener("keypress", enterSearch);

    onBeforeUnmount(() => {
      window.removeEventListener("keypress", enterSearch);
    });
const handleDel = (id) => { // 删除
  ElMessageBox.confirm(
    '是否确认删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      proxy.$httpApi.delAppraise(id).then(res => {
        if (res.IsSuccessful) {
          ElMessage({
            message: res.ResultMsg,
            type: "success",
          })
          myData.dialogVisible = false
          getTableData()
        } else {
          ElMessage({
            message: res.ResultMsg,
            type: "error",
          })
        }
      })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '您已取消删除',
      })
    })
}

const handleDetails = (item) => { // 进入详情
  window.localStorage.setItem('data', JSON.stringify(item))
  router.push(`childrenPage?taskid=${item.id}`)
}

const handleUpload1 = (data) => { // 上传附件1
  const fd = new FormData()
  fd.append('FileUrl', data.file)
  proxy.$httpApi.flieAppraise(fd).then(res => {
    if (res.IsSuccessful) {
      ElMessage({
        message: res.ResultMsg,
        type: "success",
      })
      myData.form.FileUrl = res.ResultObj
    } else {
      ElMessage({
        message: res.ResultMsg,
        type: "error",
      })
    }
  })
}

const handleUpload2 = (data) => { // 上传附件2
  const fd = new FormData()
  fd.append('FileUrl1', data.file)
  proxy.$httpApi.flieAppraise(fd).then(res => {
    if (res.IsSuccessful) {
      ElMessage({
        message: res.ResultMsg,
        type: "success",
      })
      myData.form.FileUrl1 = res.ResultObj
    } else {
      ElMessage({
        message: res.ResultMsg,
        type: "error",
      })
    }
  })
}

const handleUpload3 = (data) => { // 上传附件3
  const fd = new FormData()
  fd.append('FileUrl2', data.file)
  proxy.$httpApi.flieAppraise(fd).then(res => {
    if (res.IsSuccessful) {
      ElMessage({
        message: res.ResultMsg,
        type: "success",
      })
      myData.form.FileUrl2 = res.ResultObj
    } else {
      ElMessage({
        message: res.ResultMsg,
        type: "error",
      })
    }
  })
}

const handleReset1 = () => { // 重新上传附件1
  myData.form.FileUrl = ''
}
const handleReset2 = () => { // 重新上传附件2
  myData.form.FileUrl1 = ''
}
const handleReset3 = () => { // 重新上传附件3
  myData.form.FileUrl2 = ''
}

const getFileName = (str) => { //截取附件路径
  if (str) {
    return str.split('/').slice(-1)[0]
  } else {
    return ''
  }
}

const handleSave = () => { // 保存
  proxy.$httpApi.saveAppraise(myData.form).then(res => {
    if (res.IsSuccessful) {
      ElMessage({
        message: res.ResultMsg,
        type: "success",
      })
      myData.dialogVisible = false
      getTableData()
    } else {
      ElMessage({
        message: res.ResultMsg,
        type: "error",
      })
    }
  })
}


const handleSizeChange = (val) => {
  myData.params.rows = val
  getTableData()
}

const handleCurrentChange = (val) => {
  myData.params.Page = val
  getTableData()
}

</script>

<style lang="sass" scoped>
@use "../../assets/scss/departmentManagement.scss" as *
</style>